import React from 'react';
import useModals from 'hooks/useModals';

const withModals = (WrappedComponent) => {
  const WithModals = (props) => {
    const { showLoginModal, showEnterPinModal, showLifecellPaymentModal } = useModals();

    return (
      <WrappedComponent
        showLoginModal={showLoginModal}
        showEnterPinModal={showEnterPinModal}
        showLifecellPaymentModal={showLifecellPaymentModal}
        {...props}
      />
    );
  };

  return WithModals;
};

export default withModals;
